import React from 'react';
import GroupedMultiSelect from './GroupedMultiSelect';
import { getAllActivities } from '../../config/activityDicitionary';
import SimpleMultiSelect from './SimpleMultiSelect';

const activities = getAllActivities();
// console.log('ACTIVITIES:', activities);


function transformActivity(activity) {
  return {
    label: activity.displayName,
    value: activity.id,
    isGroup: false
  };
}

// console.log('Activities before transform:', activities);

const ActivitiesDropdown = ({ selectedValues, onChange, restrictActivities = null, ...props }) => {

  let filteredActivities = activities;
  if (restrictActivities) {
    const restrictArray = Array.isArray(restrictActivities) ? restrictActivities : [restrictActivities];
    filteredActivities = activities.filter(activity => restrictArray.includes(activity.id));
    // console.log('Filtered activities with restrictActivities:', restrictActivities, filteredActivities);
  }

  const activitiesTransformed = filteredActivities.map(transformActivity);

  return (
  <div>
    <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: 600 }}>Activity: </label>
    <SimpleMultiSelect
      options={activitiesTransformed}
      selectedValues={selectedValues}
      onChange={onChange}
      {...props}
    />
  </div>
)};

export default ActivitiesDropdown;